export class MarcacaoCachosFactory {
  constructor(instance) {
    this.instance = instance;
  }

  listMarcacoes(filter) {
    return this.instance.get('/v1/marcacao-cachos', {
      params: filter || null,
    });
  }

  getResumo(filter) {
    return this.instance.get('/v1/marcacao-cachos/resumo', {
      params: filter || null,
    });
  }

  getCodigoEmissao(filter) {
    return this.instance.get('/v1/marcacao-cachos/codigo-emissao', {
      params: filter || null,
    });
  }

  listEmissoes(filter) {
    return this.instance.get('/v1/marcacao-cachos/emissoes', {
      params: filter || null,
    });
  }

  getDashboard(filter) {
    return this.instance.get('/v1/marcacao-cachos/dashboard', {
      params: filter || null,
    });
  }

  insertMarcacao(data) {
    return this.instance.post('/v1/marcacao-cachos', data);
  }

  insertMarcacaoLote(data) {
    return this.instance.post('/v1/marcacao-cachos/lote', data);
  }

  updateMarcacao(id, data) {
    return this.instance.put(`/v1/marcacao-cachos/${id}`, data);
  }

  removeMarcacao(id) {
    return this.instance.delete(`/v1/marcacao-cachos/${id}`);
  }
}

export default (...params) => new MarcacaoCachosFactory(...params);
